import StoreBlockCatalog from '../../../components/ivy-store/store/StoreBlockCatalog'
import StoreBlockHero from '../../../components/ivy-store/store/StoreBlockHero'
import StoreBlockContacts from '../../../components/ivy-store/store/StoreBlockContacts'

import Link from 'next/link'
import { fetchSEO } from '../../../lib/blog/api'
import Seo from '../../../components/blog/Seo'
import baseUrl from '../../../lib/base-url'
import BreadCrumbs from '../../../components/ivy-store/BreadCrumbs'
import { useUser } from 'next-firebase-auth'
import populateSeoWith from '../../../lib/populate-seo'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/free-solid-svg-icons'

export const getServerSideProps = async ({ query }) => {
  const { slug } = query

  let storeData = null
  let stateData = null
  let items = []

  try {
    const storeResponse = await fetch(`${baseUrl}/api/ivy-store/store?slug=${slug}`)
    const resData = await storeResponse.json()

    if (resData.success) {
      storeData = resData.data
    } else {
      console.error('Error fetching store data:', resData)
    }
  } catch (error) {
    console.error('Error fetching store data:', error)
  }

  if (!storeData) {
    return {
      notFound: true
    }
  }

  try {
    const geographyResponse = await fetch(`${baseUrl}/api/ivy-store/geography?stateSlug=${storeData.location.state}`)
    const { data } = await geographyResponse.json()
    stateData = data
  } catch (error) {
    console.error('Failed to fetch states data:', error.message)
  }

  try {
    const itemsResponse = await fetch(`${baseUrl}/api/ivy-store/store-items?userId=${storeData.id}`)
    const itemsData = await itemsResponse.json()

    if (itemsData.success) {
      items = itemsData.data
    } else {
      console.error('Error fetching store items:', itemsData)
    }
  } catch (error) {
    console.error('Error fetching store items:', error)
  }

  const seo = await fetchSEO('ivystore-store')
  populateSeoWith(seo, {
    store_name: storeData.name,
    contact_name: storeData.data?.contact_info?.name,
    state: stateData?.name,
    city: stateData?.cities.find(city => city.slug === storeData.location.city)?.name,
  })

  return {
    props: {
      seo,
      stateData,
      storeData,
      items
    }
  }
}

export default function StorePage ({ seo, stateData, storeData, items = [] }) {
  const authUser = useUser()

  const cityData = stateData?.cities.find(city => city.slug === storeData.location.city) ?? null

  const isMyStore = storeData.id === authUser.id

  return (
    <>
      <Seo seo={seo}/>

      <div className={'d-flex flex-column'}>
        <div className={'d-flex justify-content-between'}>
          <BreadCrumbs
            stateData={stateData}
            cityData={cityData}
          />

          {isMyStore && (
            <div className={'flex-shrink-0'}>
              <Link
                href={'/app/store'}
                className={'btn btn-sm btn-light'}
              >
                <FontAwesomeIcon
                  icon={faPencil}
                  width={16}
                  height={16}
                  className={'me-1'}
                />
                Edit Store
              </Link>
            </div>
          )}
        </div>

        <div
          className={'d-flex flex-column'}
          style={{ gap: '4rem' }}
        >
          <StoreBlockHero
            storeData={storeData}
          />

          <StoreBlockCatalog
            items={items}
            storeData={storeData}
          />

          <StoreBlockContacts
            storeData={storeData}
          />
        </div>
      </div>
    </>
  )
}
